import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { LinearProgress, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useService from '../hooks/useService';
import UPPage from '../components/UPPage';
import { confirmIp } from '../lib/services/ip';
import { ErrorCodes } from '../types';

/**
 * The page of the device activate
 * @param props
 */
export default function(props: RouteComponentProps<{ token: string }>) {
  const { t } = useTranslation('translation');
  const { isRequestDone, success, send, response } = useService(
    useCallback(() => confirmIp(props.match.params.token), [props.match.params])
  );

  useEffect(() => {
    send();
  }, [send]);

  if (!isRequestDone) {
    return <LinearProgress color="primary" />;
  }

  if (!success) {
    let errorText: string = t('confirmThreatIpFailure');
    if (response?.error?.code) {
      switch (response.error.code) {
        case ErrorCodes.NOT_FOUND:
          errorText = t('confirmThreatIpNotFound');
          break;
        case ErrorCodes.IP_ALREADY_IN_WHITELIST:
          errorText = t('confirmThreatIpAlreadyWhiteList');
          break;
        case ErrorCodes.SERVER_ERROR:
          errorText = t('confirmThreatIpServerError');
          break;
      }
    }
    return (
      <UPPage>
        <Typography variant="body1" color="error">
          {errorText}
        </Typography>
      </UPPage>
    );
  }

  return (
    <UPPage>
      <Typography variant="body1">{t('confirmThreatIpSuccess')}</Typography>
      <Button href="/auth" fullWidth variant="contained" color="primary">
        {t('goToAuthorizationPage')}
      </Button>
    </UPPage>
  );
}
